import type { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'
import { STATE_DEFS } from '../common/constants'
import { BORDER_BLACK, FS_MICRO } from '../common/theme'

interface StatePillProps {
  state: string
  count?: number
  trailing?: ReactNode
}

function stateDef(state: string) {
  return STATE_DEFS.find(s => s.key === state) ?? STATE_DEFS[0]
}

export default function StatePill({
  state, count, trailing,
}: StatePillProps) {
  const def = stateDef(state)
  const label = count != null ? `${def.label} ${count}` : def.label

  return (
    <Box
      sx={{
        display: 'inline-flex', alignItems: 'center', gap: 0.5,
        height: 20, px: 1, borderRadius: '999px',
        bgcolor: def.bgcolor,
        border: 1, borderColor: 'divider',
        cursor: 'default',
        opacity: 1,
        transition: 'opacity 0.15s',
        flexShrink: 0,
        color: def.textcolor,
      }}
    >
      <Typography sx={{
        fontSize: FS_MICRO, fontWeight: 600,
        color: def.textcolor,
        mt: '1px',
        lineHeight: '10px',
        whiteSpace: 'nowrap',
      }}>
        {label}
      </Typography>
      {trailing}
    </Box>
  )
}
